import * as Yup from 'yup'

export const issuerMaturityRuleValidationSchema = Yup.object().shape({
  displayTextKey: Yup.string().required(),
  maturityDaysFrom: Yup.number().required(),
  maturityDaysTo: Yup.number().required(),
  maxLimit: Yup.number().required(),
  minLimit: Yup.number().required(),
})
